declare global {
  interface Window {
    plausible: any;
  }
}

export function createAccount() {
  const emailBtn = document.querySelector('[data-testid="create-account"]');
  const fbBtn = document.querySelector('[aria-label="Continue with Facebook"]');

  emailBtn?.addEventListener('click', function () {
    window.plausible('new_paywall_create_email_account');
  });
  fbBtn?.addEventListener('click', function () {
    window.plausible('new_paywall_create_facebook_account');
  });
}
